import { render, staticRenderFns } from "./grup46.vue?vue&type=template&id=2a46df51&scoped=true&"
import script from "./grup46.vue?vue&type=script&lang=js&"
export * from "./grup46.vue?vue&type=script&lang=js&"
import style0 from "./grup46.vue?vue&type=style&index=0&id=2a46df51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46df51",
  null
  
)

export default component.exports